import React, { PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { InputFieldWithValidation } from '../FormComponents';
import FormErrorNotification from '../FormErrorNotification';
import LoaderWithText from '../LoaderWithText';

export default (formName, validate) => {
    const ImageDestinationLocationForm = React.createClass({
        propTypes: {
            actionName: PropTypes.string.isRequired,
            onValid: PropTypes.func,
            onCancel: PropTypes.func
        },
        render: function() {
            const { handleSubmit, onValid, submitting, pristine, error, initialValues, actionName, onCancel } = this.props;

            return <div>
                <FormErrorNotification error={error} />

                <div className="control-holder">
                    <h2>Add new image location</h2>
                    <Field name="storageLocation" type="text" label="Path to folder"
                        placeholder="e.g. \\EXAMPLE-NETWORK\share1" component={InputFieldWithValidation} />
                    <p>Any SQL Server creating clones of the image needs access to this location.</p>
                </div>

                <div className="button-holder">
                    <button className="button button--primary" disabled={pristine || submitting} onClick={handleSubmit(onValid)}>
                        {actionName}
                    </button>
                    <button className="nobutton button--flat-secondary" disabled={submitting} onClick={onCancel}>
                        Cancel
                    </button>
                </div>

                {submitting && <div className="control-holder">
                    <LoaderWithText loadingText="Validating image storage location" />
                </div>}
            </div>;
        }
    });

    return reduxForm({ form: formName, validate })(ImageDestinationLocationForm);
};



// WEBPACK FOOTER //
// ./src/components/common/ImageDestinationLocationSelection/ImageDestinationLocationForm.jsx